export default __webpack_public_path__ + "static/media/english-to-turkish-screenshot-01.4d00e703.png";